<template>
  <el-container class="code-box" direction="vertical">
    <div class="page-title">【{{ cardName }}】卡密管理</div>

    <el-tabs v-model="tab">
      <el-tab-pane label="批次列表" name="batch">
        <div class="search-x">
          <el-button type="warning" v-auth="'sa_rights_card_code_generate'" @click="showGenerate = true">生成卡密</el-button>
          <el-button @click="$router.back()">返回</el-button>
        </div>
        <el-table :data="batchData" v-loading="batchLoading" border>
          <el-table-column prop="batchNo" label="批次号" min-width="180" />
          <el-table-column prop="quantity" label="数量" width="90" />
          <el-table-column prop="activatedCount" label="已激活" width="90" />
          <el-table-column prop="voidCount" label="已作废" width="90" />
          <el-table-column prop="remainCount" label="剩余" width="90" />
          <el-table-column label="可激活截止" width="170">
            <template slot-scope="{ row }">{{ formatTime(row.expireTime) || "长期" }}</template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" width="100" />
          <el-table-column label="生成时间" width="170">
            <template slot-scope="{ row }">{{ formatTime(row.createTime) }}</template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120" />
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" @click="viewBatchCodes(row)">明细</el-button>
              <el-button type="text" v-auth="'sa_rights_card_code_export'" @click="exportBatch(row)">导出状态</el-button>
              <el-button
                type="text"
                v-auth="'sa_rights_card_code_void'"
                :disabled="!(row.remainCount > 0)"
                @click="voidBatch(row)"
              >作废剩余</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-x">
          <el-pagination
            @size-change="loadBatch(true)"
            @current-change="loadBatch()"
            :current-page.sync="batchPage.pageNo"
            :page-size.sync="batchPage.pageSize"
            :page-sizes="[10, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="batchPage.total"
            background
          />
        </div>
        <p class="tip">生成成功后立即下载 CSV（含明文卡密）；明文仅此一次，后续「导出状态」不含密码。</p>
      </el-tab-pane>

      <el-tab-pane label="卡密明细" name="code">
        <div class="search-x">
          <div class="search-item">
            <span class="label">卡号</span>
            <el-input v-model.trim="codeForm.cardNo" clearable class="input-box" />
          </div>
          <div class="search-item">
            <span class="label">状态</span>
            <el-select v-model="codeForm.status" clearable placeholder="全部">
              <el-option label="未激活" :value="0" />
              <el-option label="已激活" :value="1" />
              <el-option label="作废" :value="2" />
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">激活手机</span>
            <el-input v-model.trim="codeForm.activateMobile" clearable class="input-box" />
          </div>
          <el-button type="primary" @click="loadCode(true)">查询</el-button>
          <el-button @click="resetCode">重置</el-button>
          <el-button type="primary" v-auth="'sa_rights_card_code_export'" @click="exportAll">导出状态</el-button>
          <el-button
            type="danger"
            :disabled="!selection.length"
            v-auth="'sa_rights_card_code_void'"
            @click="voidSelected"
          >作废选中</el-button>
        </div>
        <el-table :data="codeData" v-loading="codeLoading" border @selection-change="(v) => (selection = v)">
          <el-table-column type="selection" width="50" :selectable="(row) => row.status === 0" />
          <el-table-column prop="cardNo" label="卡号" min-width="160" />
          <el-table-column prop="batchNo" label="批次号" min-width="160" />
          <el-table-column prop="statusName" label="状态" width="90" />
          <el-table-column prop="activateMobile" label="激活手机" width="130">
            <template slot-scope="{ row }">{{ row.activateMobile || "-" }}</template>
          </el-table-column>
          <el-table-column label="激活时间" width="170">
            <template slot-scope="{ row }">{{ formatTime(row.activateTime) }}</template>
          </el-table-column>
          <el-table-column label="有效期" min-width="200">
            <template slot-scope="{ row }">
              <span v-if="row.beginTime">{{ formatTime(row.beginTime) }} ~ {{ formatTime(row.endTime) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                v-if="row.status === 0"
                v-auth="'sa_rights_card_code_void'"
                @click="voidOne(row)"
              >作废</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-x">
          <el-pagination
            @size-change="loadCode(true)"
            @current-change="loadCode()"
            :current-page.sync="codePage.pageNo"
            :page-size.sync="codePage.pageSize"
            :page-sizes="[10, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="codePage.total"
            background
          />
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="生成卡密" :visible.sync="showGenerate" width="480px" @close="resetGen">
      <el-form label-width="120px">
        <el-form-item label="生成数量" required>
          <el-input-number v-model="genForm.quantity" :min="1" :max="5000" />
        </el-form-item>
        <el-form-item label="可激活截止">
          <el-date-picker
            v-model="genForm.expireTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="不填则长期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="genForm.remark" maxlength="100" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showGenerate = false">取消</el-button>
        <el-button type="primary" :loading="genLoading" @click="doGenerate">生成并下载</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { dateFormat } from "@/assets/js/until.js";

export default {
  name: "rightsCardCode",
  data() {
    return {
      tab: "batch",
      batchLoading: false,
      codeLoading: false,
      genLoading: false,
      showGenerate: false,
      batchData: [],
      codeData: [],
      selection: [],
      batchPage: { pageNo: 1, pageSize: 10, total: 0 },
      codePage: { pageNo: 1, pageSize: 10, total: 0 },
      codeForm: { batchId: null },
      genForm: { quantity: 100, expireTime: null, remark: "" },
    };
  },
  computed: {
    cardId() {
      return this.$route.query.cardId;
    },
    cardName() {
      return this.$route.query.cardName || "权益卡";
    },
  },
  created() {
    if (!this.cardId) {
      this.$message.error("缺少 cardId");
      this.$router.back();
      return;
    }
    this.loadBatch(true);
    this.loadCode(true);
  },
  methods: {
    formatTime(t) {
      return t ? dateFormat(t, "Y/m/d H:i:s") : "";
    },
    resetGen() {
      this.genForm = { quantity: 100, expireTime: null, remark: "" };
    },
    resetCode() {
      this.codeForm = { batchId: this.codeForm.batchId || null };
      this.loadCode(true);
    },
    async loadBatch(reset) {
      if (reset) this.batchPage.pageNo = 1;
      this.batchLoading = true;
      try {
        const res = await this.axios.get(this.getApiUrl("rightsCardCodeBatchPage"), {
          params: {
            cardId: this.cardId,
            pageNo: this.batchPage.pageNo,
            pageSize: this.batchPage.pageSize,
          },
        });
        const data = res.data || {};
        this.batchData = data.data || [];
        this.batchPage.total = data.total || 0;
      } finally {
        this.batchLoading = false;
      }
    },
    async loadCode(reset) {
      if (reset) this.codePage.pageNo = 1;
      this.codeLoading = true;
      try {
        const res = await this.axios.get(this.getApiUrl("rightsCardCodePage"), {
          params: {
            cardId: this.cardId,
            ...this.codeForm,
            pageNo: this.codePage.pageNo,
            pageSize: this.codePage.pageSize,
          },
        });
        const data = res.data || {};
        this.codeData = data.data || [];
        this.codePage.total = data.total || 0;
      } finally {
        this.codeLoading = false;
      }
    },
    viewBatchCodes(row) {
      this.codeForm = { batchId: row.id };
      this.tab = "code";
      this.loadCode(true);
    },
    exportBatch(row) {
      const url =
        this.getApiUrl("rightsCardCodeExport") +
        `?cardId=${this.cardId}&batchId=${row.id}`;
      window.open(url, "_blank");
    },
    exportAll() {
      let url = this.getApiUrl("rightsCardCodeExport") + `?cardId=${this.cardId}`;
      if (this.codeForm.batchId) url += `&batchId=${this.codeForm.batchId}`;
      if (this.codeForm.status !== undefined && this.codeForm.status !== null && this.codeForm.status !== "") {
        url += `&status=${this.codeForm.status}`;
      }
      window.open(url, "_blank");
    },
    voidBatch(row) {
      this.$confirm(`确定作废批次 ${row.batchNo} 下全部未激活卡密？`, "提示", { type: "warning" })
        .then(async () => {
          const res = await this.axios.post(
            this.getApiUrl("rightsCardCodeVoid"),
            { batchId: row.id },
            { toJSON: true }
          );
          if (res && res.code === 1) {
            this.$message.success("作废成功：" + (res.data || 0) + " 张");
            this.loadBatch();
            this.loadCode();
          } else {
            this.$message.error((res && res.msg) || "作废失败");
          }
        })
        .catch(() => {});
    },
    voidOne(row) {
      this.$confirm(`确定作废卡号 ${row.cardNo}？`, "提示", { type: "warning" })
        .then(async () => {
          const res = await this.axios.post(
            this.getApiUrl("rightsCardCodeVoid"),
            { ids: [row.id] },
            { toJSON: true }
          );
          if (res && res.code === 1) {
            this.$message.success("作废成功");
            this.loadBatch();
            this.loadCode();
          } else {
            this.$message.error((res && res.msg) || "作废失败");
          }
        })
        .catch(() => {});
    },
    voidSelected() {
      const ids = this.selection.map((x) => x.id);
      this.$confirm(`确定作废选中的 ${ids.length} 张未激活卡？`, "提示", { type: "warning" })
        .then(async () => {
          const res = await this.axios.post(
            this.getApiUrl("rightsCardCodeVoid"),
            { ids },
            { toJSON: true }
          );
          if (res && res.code === 1) {
            this.$message.success("作废成功");
            this.loadBatch();
            this.loadCode();
          } else {
            this.$message.error((res && res.msg) || "作废失败");
          }
        })
        .catch(() => {});
    },
    async doGenerate() {
      if (!this.genForm.quantity || this.genForm.quantity < 1) {
        this.$message.warning("请输入生成数量");
        return;
      }
      this.genLoading = true;
      try {
        const res = await this.axios.post(
          this.getApiUrl("rightsCardCodeGenerate"),
          {
            cardId: Number(this.cardId),
            quantity: this.genForm.quantity,
            expireTime: this.genForm.expireTime || null,
            remark: this.genForm.remark || "",
          },
          { toJSON: true }
        );
        if (!(res && res.code === 1 && res.data)) {
          this.$message.error((res && res.msg) || "生成失败");
          return;
        }
        const list = res.data.list || [];
        const lines = ["卡号,卡密,产品名称,批次号"];
        list.forEach((row) => {
          lines.push(
            [row.cardNo, row.plainPassword, row.cardName, row.batchNo]
              .map((x) => `"${String(x || "").replace(/"/g, '""')}"`)
              .join(",")
          );
        });
        const bom = "\uFEFF";
        const blob = new Blob([bom + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `权益卡卡密_${res.data.batchNo || Date.now()}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.$message.success(`生成成功 ${res.data.quantity || list.length} 张，已下载（明文仅此一次）`);
        this.showGenerate = false;
        this.loadBatch(true);
        this.loadCode(true);
      } catch (e) {
        this.$message.error((e && e.msg) || "生成失败");
      } finally {
        this.genLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.code-box {
  padding: 16px;
}
.page-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.search-x {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 0 12px 8px 0;
}
.search-item .label {
  margin-right: 8px;
  white-space: nowrap;
}
.input-box {
  width: 180px;
}
.page-x {
  margin-top: 12px;
  text-align: right;
}
.tip {
  margin-top: 12px;
  color: #909399;
  font-size: 13px;
}
</style>
